import { Component } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { DeliveryNoteService } from '../../services/delivery-note.service';
import { NoteStatus, TYPE_LABELS, statusBadge, ukDate } from '../../models/delivery-note.models';

/** Open picking slips: delivery notes ready to pick or part picked. */
@Component({
    selector: 'app-picking-slips',
    templateUrl: './picking-slips.component.html',
    standalone: false
})
export class PickingSlipsComponent {
  error: string = '';

  filters: GridFilter[] = [{ field: 'status', condition: 'in', value: ['ready', 'part_picked'] } as GridFilter];

  buttons: GridButton[] = [
    { label: '<i class="fas fa-clipboard-check"></i> Pick', link: '/picking-slips/:id', type: 'btn-info' } as GridButton,
    { label: '<i class="fas fa-file-pdf"></i>', type: 'btn-secondary', action: (b, r) => this.print(r) } as GridButton,
  ];

  columns: GridColumn[] = [
    { active: true, label: 'Picking slip', field: 'noteNumber', value: (v) => v ? 'PS-' + String(v).replace(/^[A-Za-z]+-?/, '') : '' } as GridColumn,
    { active: true, label: 'Delivery note', field: 'noteNumber' } as GridColumn,
    { active: true, label: 'Type', field: 'noteType', value: (v) => TYPE_LABELS[v] || v } as GridColumn,
    { active: true, label: 'Customer', field: 'account.name', value: (v, r) => r.account ? r.account.name : '' } as GridColumn,
    { active: true, label: 'Required', field: 'requiredDate', value: (v) => ukDate(v) } as GridColumn,
    { active: true, label: 'Status', field: 'status', value: (v: NoteStatus) => statusBadge(v) } as GridColumn,
  ];

  searchFields: string[] = ['noteNumber', 'account.name', 'customerRef'];
  searchFilters: GridSearchFilter[] = [
    { field: 'noteNumber', label: 'Number' } as GridSearchFilter,
    { field: 'account.name', label: 'Customer' } as GridSearchFilter,
    { field: 'requiredDate', label: 'Required', type: 'date' } as GridSearchFilter,
  ];

  constructor(private service: DeliveryNoteService) { }

  print(record: any): void {
    this.error = '';
    this.service.pdf(record.id, 'picking-slip').pipe(take(1)).subscribe({
      next: (url) => window.open(url, '_blank'),
      error: () => this.error = 'The picking slip could not be printed. Please try again.',
    });
  }
}
